// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.turnstile-module_wrapper__C0T2D {
    display: flex;
    justify-content: center;
    width: 100%;
}

.turnstile-module_container__IVDRP {
    display: flex;
    justify-content: center;
}

.turnstile-module_flexible__QIbyz {
    width: 100%;
    min-width: 300px;
    min-height: 65px;
}

.turnstile-module_normal__CrR9d {
    width: 300px;
    min-height: 65px;
}

.turnstile-module_compact__xcZdi {
    width: 150px;
    min-height: 140px;
}

/* Cloudflare shows the iframe only when interaction is needed and collapses it afterwards. */
.turnstile-module_interactionOnly__PWPWl {
    min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Turnstile/turnstile.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA,6FAA6F;AAC7F;IACI,aAAa;AACjB","sourcesContent":[".wrapper {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.container {\n    display: flex;\n    justify-content: center;\n}\n\n.flexible {\n    width: 100%;\n    min-width: 300px;\n    min-height: 65px;\n}\n\n.normal {\n    width: 300px;\n    min-height: 65px;\n}\n\n.compact {\n    width: 150px;\n    min-height: 140px;\n}\n\n/* Cloudflare shows the iframe only when interaction is needed and collapses it afterwards. */\n.interactionOnly {\n    min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `turnstile-module_wrapper__C0T2D`,
	"container": `turnstile-module_container__IVDRP`,
	"flexible": `turnstile-module_flexible__QIbyz`,
	"normal": `turnstile-module_normal__CrR9d`,
	"compact": `turnstile-module_compact__xcZdi`,
	"interactionOnly": `turnstile-module_interactionOnly__PWPWl`
};
export default ___CSS_LOADER_EXPORT___;
